import React, { useContext } from 'react';
import styled from 'styled-components';
import { TabSelect } from '@/components/tab-select';
import { SummaryContext } from '@/features/details/summary/context';
import { PriceTestReportsProvider } from '@/features/details/price-test-reports/context';
import { PriceTestProductsList } from '@/features/details/price-test-reports/products-list';
import {
  DeskHidden,
  MobileHidden,
} from '@/features/details/price-test-reports/shared';
import { Experience } from '@/webapi/use-experience-api';
import { usePriceTestReportApi } from '@/features/details/price-test-reports/api';
import { ErrorBoundary } from '@/features/shared/error-boundary';

interface PriceTestReportsProps {
  experience?: Experience;
  setExperience?: (e: Experience) => void;
}

export function PriceTestReports({
  experience,
  setExperience,
}: PriceTestReportsProps) {
  const { showPriceTestReport } = useContext(SummaryContext);
  if (!showPriceTestReport) {
    return null;
  }
  return (
    <PriceTestReportsProvider experience={experience}>
      <ErrorBoundary>
        <PriceTestProductsList
          experience={experience}
          setExperience={setExperience}
        />
      </ErrorBoundary>
    </PriceTestReportsProvider>
  );
}

export function PriceTestSwitch() {
  const {
    setShowPriceTestReport,
    showPriceTestReport,
    isPriceTestReportEnabled,
    expId,
  } = useContext(SummaryContext);
  const { setReportType } = usePriceTestReportApi();

  if (!isPriceTestReportEnabled) {
    return null;
  }

  const onTabSelected = (e) => {
    const isPriceTest = e === 1;
    setReportType(isPriceTest, expId);
    setShowPriceTestReport(isPriceTest);
  };
  const defaultValue = showPriceTestReport
    ? `Impact on Products with Price Changes`
    : `Impact on All Visitors`;
  return (
    <Container>
      <MobileHidden>
        <TabSelect
          onTabSelected={onTabSelected}
          tabHeight={3}
          tabFont={`'Inter', sans-serif;`}
          tabFontSize="1.2rem"
          tabWidth={50}
          tabs={[
            `Impact on All Visitors`,
            `Impact on Products with Price Changes`,
          ]}
          defaultValue={defaultValue}
        />
      </MobileHidden>
      <DeskHidden>
        <MobileMenu
          type="button"
          onClick={() => setShowPriceTestReport(!showPriceTestReport)}
        >
          <TabSelect
            onTabSelected={onTabSelected}
            tabHeight={5}
            tabFont={`'Inter', sans-serif;`}
            tabFontSize="1.2rem"
            tabWidth={20}
            tabs={[
              `Impact on All Visitors`,
              `Impact on Products with Price Changes`,
            ]}
            defaultValue={defaultValue}
          />
        </MobileMenu>
      </DeskHidden>
    </Container>
  );
}

const MobileMenu = styled.button`
  color: #4f5359;
`;
const Container = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
  margin-bottom: 30px;
`;
